import axios from "axios";
import { config } from "../constants";
import { authHeader } from "../helpers";

export const authenticationService = {
  authHeader,
  registerDevice,
  authenticateDevice,
  getOrganizationDetails,
  getOrganizationLogo,
};

async function registerDevice(deviceId, browserType, browserInfo, appCode, orgCode) {
  const domain = window.location.host.split(".")[0];
  const applicationCode = appCode ||
    (domain && domain.length > 1 && domain.toLowerCase()?.startsWith("www") ? "CVD" : "CVDB");
  const options = {
    baseURL: config.apiUrl,
    url: "/register",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: {
      appCode: applicationCode,
      organizationCode: orgCode,
      deviceId: deviceId,
      deviceType: browserType,
      deviceDetails: JSON.stringify({ browserInfo: browserInfo }),
      appVersion: "1.0.0",
    },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    if (data.success) {
      localStorage.setItem("orgCode", orgCode);
      localStorage.setItem("appCode", applicationCode);
      localStorage.setItem("deviceId", deviceId);
      sessionStorage.setItem("refreshToken", JSON.stringify(data.data));
    } else {
      localStorage.removeItem("orgCode");
      localStorage.removeItem("appCode");
      localStorage.removeItem("deviceId");
      // sessionStorage.removeItem("refreshToken");
    }
    return data;
  } catch (error) {
    localStorage.removeItem("orgCode");
    localStorage.removeItem("appCode");
    localStorage.removeItem("deviceId");
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function authenticateDevice(token) {
  const queryParams = new URLSearchParams(window?.location?.search);
  let campaignInfo = {};
  for (const param of queryParams) {
    campaignInfo[param[0]] = param[1];
  }
  const refreshToken = JSON.parse(sessionStorage.getItem("refreshToken"));

  const options = {
    baseURL: config.apiUrl,
    url: "/authenticate",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: {
      refreshToken: token || refreshToken,
      appVersion: "1.0 Build 25",
      appCode: localStorage.getItem("appCode"),
      orgCode: localStorage.getItem("orgCode"),
      campaignInfo: campaignInfo,
    },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));
    sessionStorage.setItem("jwtToken", JSON.stringify(data?.data?.jwtToken));
    sessionStorage.setItem("applicationData", JSON.stringify(data?.data));
    
    if (data?.data?.appUser !== null) {
      sessionStorage.setItem("isLoggedIn", true);
    } else {
      sessionStorage.removeItem("isLoggedIn");
    }

    localStorage.setItem(
      "pharmacyGroupId",
      isLoggedIn
        ? data?.data?.appUser?.pharmacyGroupId
        : data?.data?.device?.pharmacyGroupId
    );
    localStorage.setItem("orgCode", data?.data?.organization?.code);
    window.updateFavIcon();
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getOrganizationDetails() {
  const options = {
    baseURL: config.apiUrl,
    url: "/organization/",
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getOrganizationLogo() {
  const options = {
    baseURL: config.apiUrl,
    url: "/organization/logo",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

function handleResponse(response) {
  if (response.status !== 200) {
    if (response.status === 401) {
      return response;
    } else {
      const error = response.status;
      return Promise.reject(error);
    }
  }
  return response.data;
}

